const planTypesData = [
  {
    _id: 1,
    name: "Rollover",
    planInfo: [
      "Lorem ipsum dolor sit amet.",
      "Lorem, ipsum dolor sit amet consectetur adipisicing elit.",
      "Odd of 1.30 each day for 10 days",
    ],
    price: 200,
    duration: "10 Days",
    start: "Start at least $5.00",
  },
  // {
  //   _id: 2,
  //   name: "Correct Score",
  //   planInfo: [
  //     "Lorem ipsum dolor sit amet.",
  //     "Lorem, ipsum dolor sit amet consectetur adipisicing elit.",
  //     "Odd of 1.30 each day for 10 days",
  //   ],
  //   price: 200,
  //   duration: "10 Days",
  // },
  {
    _id: 3,
    name: "Premium",
    planInfo: [
      "Lorem ipsum dolor sit amet.",
      "Lorem, ipsum dolor sit amet consectetur adipisicing elit.",
      "Odd of 1.30 each day for 10 days",
    ],
    price: 200,
    duration: "10 Days",
    start: "Start at least $5.00",
  },
];


export default planTypesData;